import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import "./App.css";
import Portfolio from "./components/Portfolio";
import Resume from "./components/Resume";
import Contacts from "./components/Contacts";
import AppErrorBoundary from "./components/AppErrorBoundary";
import { ColorThemeProvider } from "./hooks/useColorTheme";

function App() {
  return (
    <div className="App w-full max-w-full overflow-x-hidden">
      {/* 테마 선택(브라우저 테마·햇빛·달빛)은 모든 페이지가 함께 쓰고 기억한다 — 오류 복구 때도 유지되게 라우터·AppErrorBoundary 바깥 (CLAUDE.md Phase 22) */}
      <ColorThemeProvider>
        <BrowserRouter>
          {/* 렌더링 오류가 나도 흰 화면 대신 복구·안내 (CLAUDE.md Phase 8) */}
          <AppErrorBoundary>
            <Routes>
              <Route path="/" element={<Portfolio />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/contacts" element={<Contacts />} />
            </Routes>
          </AppErrorBoundary>
        </BrowserRouter>
      </ColorThemeProvider>
      <Analytics />
    </div>
  );
}

export default App;